import type { SVGProps, FC } from "react";
import IconCloseSvg from "~/shared/ui/icon/svg/sceneTabSvg/close.svg";
import IconPlaySvg from "~/shared/ui/icon/svg/sceneTabSvg/play.svg";
import IconPauseSvg from "~/shared/ui/icon/svg/sceneTabSvg/pause.svg";

type SvgProps = Omit<SVGProps<SVGSVGElement>, "children" | "ref">;
type svgType = FC<React.SVGProps<SVGSVGElement>>;

const SvgIcon = (Icon: svgType, { className, ...props }: SvgProps) => (
    <Icon className={className} {...props} />
);

// Тонкие обёртки над импортированными `.svg`-компонентами: каждая прокидывает
// `className`/`props` через общий `SvgIcon`. Здесь остались только те, у кого
// есть потребитель, — остальные 48 обёрток и их спрайты удалены как мёртвые.

/** Иконка закрытия диалога — крестик в шапке модалок подтверждения. */
export const IconClose = (props: SvgProps) => SvgIcon(IconCloseSvg as svgType, props);
/** Кнопка воспроизведения в контролах видео-превью админки. */
export const IconPlay = (props: SvgProps) => SvgIcon(IconPlaySvg as svgType, props);
/** Кнопка паузы там же, парная к `IconPlay`. */
export const IconPause = (props: SvgProps) => SvgIcon(IconPauseSvg as svgType, props);
